function lushSliderInit() {
  if (window.innerWidth < 768) {
    if (!$('.lush-slider').hasClass('slick-initialized')) {
      $('.lush-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow:"<img alt='prev' class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0791/5978/7745/files/prevoius-arrow.png?v=1762431695'>",
        nextArrow:"<img alt='next' class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0791/5978/7745/files/next-arrow.png?v=1762431610'>"
      });
    }
  } else {
    if ($('.lush-slider').hasClass('slick-initialized')) {
      $('.lush-slider').slick('unslick');
    }
  }
}

$(document).ready(function () {
  lushSliderInit();
});

$(window).on('resize', function () {
  lushSliderInit();
});
$('.lush_trend_slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            dots: false,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3 } },
                { breakpoint: 768, settings: { slidesToShow: 2 } },
                { breakpoint: 480, settings: { slidesToShow: 1 } }
            ]
        });
$('.custom-tab').on('click', function () { 
setTimeout(function () {
        $('.lush_trend_slider').slick('setPosition');
    }, 100);
     
});
  $('.lush-trend-btn').on('click', function(event) {
    event.preventDefault();
    var $button = $(this);

    if ($button.hasClass('is-loading')) {
      return;
    }

    var vid = $button.data('vid');
    setButtonLoading(true);

    function setButtonLoading(isLoading) {
      $button.toggleClass('is-loading', isLoading);
      $button.prop('disabled', isLoading);
    }

    function resetButton() {
      setButtonLoading(false);
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({ id: vid, quantity: 1 }),
      dataType: 'json',
      contentType: 'application/json',
      success: function() {
        import('@theme/events')
          .then(({ CartUpdateEvent }) => {
            const cartDrawer = document.querySelector('cart-drawer-component');    
            return fetch('/cart.js')
              .then(res => res.json())
              .then(cart => {
                const event = new CartUpdateEvent(cart, 'manual-trigger', {
                  itemCount: cart.item_count,
                  source: 'fad-refresh',
                  sections: {}
                });
                document.dispatchEvent(event);
                if (cartDrawer?.hasAttribute('auto-open')) {
                  cartDrawer.open();
                }
              });
          })
          .catch(function(error) {
            console.error('Cart refresh failed:', error);
          })
          .finally(resetButton);
      },
      error: function() {
        // optional: could show toast / alert
        resetButton();
      }
    });
  });

(function(){
  function r(){
    document.querySelectorAll("a,span,div,li").forEach(e=>{
      const t=e.textContent.trim();
      if(t==="catalog") e.textContent="catalogue";
      else if(t==="Catalog") e.textContent="Catalogue";
      else if(t==="CATALOG") e.textContent="CATALOGUE";
    });
  }
  r();
  new MutationObserver(r).observe(document.body,{childList:true,subtree:true});
})();








document.addEventListener('DOMContentLoaded', () => {
  runVariantAI();
});

document.addEventListener('change', (e) => {
  if (e.target.closest('variant-picker')) {
    setTimeout(runVariantAI, 50);
  }
});

function runVariantAI() {
  const selected = document.querySelector('variant-picker select option[selected], variant-picker input:checked');
  const variantId = selected?.dataset?.variantId || null;

  const elements = document.querySelectorAll('.varaint_url');

  if (!elements.length) return;

  let hasMultiple = elements.length > 1;
  let matched = false;

  elements.forEach((el) => {
    el.classList.remove('active');

    if (variantId && el.dataset.vid === variantId) {
      el.classList.add('active');
      matched = true;
    }
  });




  if (!hasMultiple) {
    elements.forEach((el) => el.classList.add('active'));
    return;
  }

  if (!matched) {
    elements.forEach((el) => el.classList.remove('active'));
  }
}